import { Materials } from "./materials.js";
import { WeaponSubtypes } from "./weaponSubtypes.js";

export const Zones = {
  OUTSKIRTS: {
    name: "Outskirts",
    monsters: ["THUG", "PICKPOCKET", "BANDIT", "BANDIT_ARCHER"],
    upgradeId: null
  },
  FOREST: {
    name: "Forest",
    monsters: ["GOBLIN", "GOBLIN_ARCHER", "GOBLIN_CHIEF", "FOREST_SPIDER"],
    upgradeId: "zone_forest"
  },
  MOUNTAINS: {
    name: "Mountains",
    monsters: ["ORC", "ORC_BERSERKER", "TROLL", "HARPY"],
    upgradeId: "zone_mountains"
  },
  DUNGEON: {
    name: "Dungeon",
    monsters: ["SKELETON", "SKELETON_ARCHER", "DARK_KNIGHT", "NECROMANCER"],
    upgradeId: "zone_dungeon"
  },
};

export const Monsters = {
  THUG: {
    name: "Thug",
    health: 25,
    weapon: { subtype: WeaponSubtypes.CLUB, material: Materials.IRON },
    minRoll: 1,
    maxRoll: 2,
    drops: [],
  },
  PICKPOCKET: {
    name: "Pickpocket",
    health: 20,
    weapon: { subtype: WeaponSubtypes.DAGGER, material: Materials.IRON },
    minRoll: 1,
    maxRoll: 2,
    drops: [],
  },
  BANDIT: {
    name: "Bandit",
    health: 35,
    weapon: { subtype: WeaponSubtypes.SHORTSWORD, material: Materials.IRON },
    minRoll: 1,
    maxRoll: 3,
    drops: [],
  },
  BANDIT_ARCHER: {
    name: "Bandit Archer",
    health: 30,
    weapon: { subtype: WeaponSubtypes.CROSSBOW, material: Materials.IRON },
    minRoll: 1,
    maxRoll: 3,
    drops: [],
  },

  GOBLIN: {
    name: "Goblin",
    health: 45,
    weapon: { subtype: WeaponSubtypes.CLUB, material: Materials.IRON },
    minRoll: 2,
    maxRoll: 3,
    drops: [],
  },
  GOBLIN_ARCHER: {
    name: "Goblin Archer",
    health: 35,
    weapon: { subtype: WeaponSubtypes.CROSSBOW, material: Materials.IRON },
    minRoll: 2,
    maxRoll: 3,
    drops: [],
  },
  FOREST_SPIDER: {
    name: "Forest Spider",
    health: 50,
    weapon: { subtype: WeaponSubtypes.DAGGER, material: Materials.STEEL },
    minRoll: 2,
    maxRoll: 4,
    drops: [],
  },
  GOBLIN_CHIEF: {
    name: "Goblin Chief",
    health: 70,
    weapon: { subtype: WeaponSubtypes.SHORTSWORD, material: Materials.STEEL },
    minRoll: 2,
    maxRoll: 4,
    drops: [],
  },

  ORC: {
    name: "Orc Warrior",
    health: 80,
    weapon: { subtype: WeaponSubtypes.SHORTSWORD, material: Materials.STEEL },
    minRoll: 3,
    maxRoll: 4,
    drops: [],
  },
  ORC_BERSERKER: {
    name: "Orc Berserker",
    health: 100,
    weapon: { subtype: WeaponSubtypes.LONGSWORD, material: Materials.STEEL },
    minRoll: 3,
    maxRoll: 4,
    drops: [],
  },
  HARPY: {
    name: "Harpy",
    health: 60,
    weapon: { subtype: WeaponSubtypes.CROSSBOW, material: Materials.SILVER },
    minRoll: 3,
    maxRoll: 5,
    drops: [],
  },
  TROLL: {
    name: "Mountain Troll",
    health: 150,
    weapon: { subtype: WeaponSubtypes.CLUB, material: Materials.SILVER },
    minRoll: 3,
    maxRoll: 5,
    drops: [],
  },

  SKELETON: {
    name: "Skeleton",
    health: 70,
    weapon: { subtype: WeaponSubtypes.SHORTSWORD, material: Materials.SILVER },
    minRoll: 4,
    maxRoll: 5,
    drops: [],
  },
  SKELETON_ARCHER: {
    name: "Skeleton Archer",
    health: 55,
    weapon: { subtype: WeaponSubtypes.CROSSBOW, material: Materials.SILVER },
    minRoll: 4,
    maxRoll: 5,
    drops: [],
  },
  DARK_KNIGHT: {
    name: "Dark Knight",
    health: 140,
    weapon: { subtype: WeaponSubtypes.LONGSWORD, material: Materials.GOLD },
    minRoll: 4,
    maxRoll: 5,
    drops: [],
  },
  NECROMANCER: {
    name: "Necromancer",
    health: 90,
    weapon: { subtype: WeaponSubtypes.REVOLVER, material: Materials.GOLD },
    minRoll: 4,
    maxRoll: 5,
    drops: [],
  },
};
